/**
 * Rubina Irfan - Global Scripts
 * Scroll reveal animations and shared functionality
 */

// Scroll Reveal Observer
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(el => {
    if (el.isIntersecting) {
      el.target.classList.add('ri-visible');
      revealObserver.unobserve(el.target);
    }
  });
}, { threshold: 0.12 });

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ri-reveal').forEach(el => {
    revealObserver.observe(el);
  });
});

// Re-initialize for dynamically added content (Shopify sections)
window.reinitScrollReveal = () => {
  document.querySelectorAll('.ri-reveal:not(.ri-visible)').forEach(el => {
    revealObserver.observe(el);
  });
};

// Shopify section reload support
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', window.reinitScrollReveal);
}
